module.exports = __webpack_public_path__ + "img/login_background-2.7922da01.png";